import Mail from './Mail.json';
import Bms from './BookMyShow.json';
import PaytmInsider from './PaytmInsider.json';
import SearchBar from './SearchBar.json';
import District from './District.json';

export{
  Mail,
  Bms,
  PaytmInsider,
  SearchBar,
  District,
};